import cloneDeep from 'lodash/cloneDeep';
import { TShare } from '../../share.model';

export function correctFlagAccessLogic(share: TShare): boolean {
  let flagPermission = cloneDeep(share.advancedAccessLevels.flags.permission.edit);

  flagPermission = !flagPermission;

  return flagPermission;
}
